// Phone input with country code. Default India (+91), international allowed.
const DIAL_CODES = ["+91", "+1", "+44", "+971", "+61", "+65", "+49", "+33", "+27", "+64", "+880", "+92"];

const inputCls =
  "rounded-xl border border-border bg-white px-3 py-3 text-sm text-slate-900 transition-[border-color,box-shadow] focus:border-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-600/15";

export const PhoneField = ({ dial, number, onDial, onNumber, testId = "phone" }) => (
  <div className="flex gap-2">
    <select
      value={dial}
      onChange={(e) => onDial(e.target.value)}
      data-testid={`${testId}-code`}
      className={`${inputCls} w-24 shrink-0`}
    >
      {DIAL_CODES.map((c) => (
        <option key={c} value={c}>{c}</option>
      ))}
    </select>
    <input
      inputMode="tel"
      value={number}
      data-testid={testId}
      onChange={(e) => onNumber(e.target.value.replace(/[^\d]/g, "").slice(0, 14))}
      placeholder="98765 43210"
      className={`${inputCls} flex-1`}
    />
  </div>
);
